import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function FileUpload(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M14.885 0a1.178 1.178 0 0 0-.108.014H7.355C4.278.004 1.73 2.48 1.659 5.558a1.178 1.178 0 0 0 0 .028V18.35c-.052 3.052 2.403 5.596 5.456 5.65a1.178 1.178 0 0 0 .021 0c.061 0 .139 0 .219-.002h9.413a1.178 1.178 0 0 0 .011 0c3.072-.032 5.568-2.559 5.563-5.63V7.411a1.178 1.178 0 0 0-.329-.815L16.043.377a1.178 1.178 0 0 0-.85-.363h-.137a1.178 1.178 0 0 0-.17-.014ZM7.35 2.37a1.178 1.178 0 0 0 .005 0h6.352v2.235c0 2.31 1.892 4.208 4.2 4.214a1.178 1.178 0 0 0 .005 0h2.073v9.552a1.178 1.178 0 0 0 0 .002 3.245 3.245 0 0 1-3.229 3.268H7.355a1.178 1.178 0 0 0-.037 0l-.161.002a3.18 3.18 0 0 1-3.142-3.252 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.003 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.003 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.002 1.178 1.178 0 0 0 0-.002V5.613A3.304 3.304 0 0 1 7.35 2.371Zm8.714 1.43 2.557 2.663h-.709a1.838 1.838 0 0 1-1.848-1.858Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M11.785 9.089a1.178 1.178 0 0 0-1.178 1.178v1.71h-1.71a1.178 1.178 0 0 0-1.179 1.178 1.178 1.178 0 0 0 1.179 1.179h1.71v1.707a1.178 1.178 0 0 0 1.178 1.179 1.178 1.178 0 0 0 1.179-1.179v-1.707h1.707a1.178 1.178 0 0 0 1.179-1.179 1.178 1.178 0 0 0-1.179-1.178h-1.707v-1.71a1.178 1.178 0 0 0-1.179-1.178Z"
        fill="currentColor"
      />
    </IconWrapper>
  );
}
